import { IFilters } from "@/interfaces/search";
import router from "@/router";


function prepareQueryParams(page: number, query: string, filters: IFilters, contentFilter: { [key: string]: string; }) {
  const queryParams: Record<string, string | number> = {};

  if (query !== '') {
    queryParams["q"] = query;
  }
  queryParams["page"] = page;

  let addContentFilterToQueryParams = false
  for (const key in filters) {
    const filterKey = key as keyof IFilters;
    if (
      typeof filters[filterKey] === "number" ||
      typeof filters[filterKey] === "string"
    ) {
      queryParams[key] = (
        filters[filterKey] as number | string
      ).toString();
    } else if (filters[filterKey] instanceof Date) {
      queryParams[key] = (filters[filterKey] as Date).toISOString().slice(0, 10);
    }
    if (key in contentFilter && contentFilter[key] !== filters[filterKey]) {
      addContentFilterToQueryParams = true
    }
  }

  if ('company' in queryParams && router.currentRoute.value.name === 'company' && !addContentFilterToQueryParams) {
    delete queryParams['company']
  }
  if ('source' in queryParams && router.currentRoute.value.name === 'sourceSerp' && !addContentFilterToQueryParams) {
    delete queryParams['source']
  }
  if ('type' in queryParams && router.currentRoute.value.name === 'typeSerp' && !addContentFilterToQueryParams) {
    delete queryParams['type']
  }
  if ('region' in queryParams && router.currentRoute.value.name === 'regionSerp' && !addContentFilterToQueryParams) {
    delete queryParams['region']
  }
  if ('category' in queryParams && router.currentRoute.value.name === 'categorySerp' && !addContentFilterToQueryParams) {
    delete queryParams['category']
  }

  return queryParams
}


function prepareSearchPayload(
  page: number, 
  query: string, 
  filters: IFilters, 
  include_ngrams?: boolean,
  page_refreshed?: boolean,
) {
  const searchPayload: Record<string, string | number | IFilters | boolean> = {
    page: page
  }
  if (query !== '') {
    searchPayload.query = query
  }
  if (Object.keys(filters).length !== 0) {
    searchPayload.filters = filters
  }
  if (include_ngrams) {
    searchPayload.include_ngrams = include_ngrams
  }
  if (page_refreshed) {
    searchPayload.page_refreshed = page_refreshed
  }

  return searchPayload
}

function isNonSubscribableFilter(filters: IFilters) {
  if (Object.keys(filters).length === 0) {
    return false
  }
  const hasStatus = !!filters.status;
  const dateFilterKeys = ['endDateFrom', 'endDateTo', 'startDateFrom', 'startDateTo'] as Array<keyof IFilters>;
  const activeDateFilters = dateFilterKeys.filter(key => filters[key] !== undefined);

  const totalActiveFilters = Object.keys(filters).length;
  const nonSubscribableFilterCount = (hasStatus ? 1 : 0) + activeDateFilters.length;

  return totalActiveFilters === nonSubscribableFilterCount;
}

export { prepareQueryParams, prepareSearchPayload, isNonSubscribableFilter }
